<div class="logo"><img src="./assets/images/jio-logo.png"></div>
<div class="tagline">world <br> convention <br> centre </div>
<div class="tagline3"><span>mumbai</span></div>
<div class="tagline2">where events come to life</div>
<div class="explorebtn" id="hap6"><button type="button" id="hap6_I" (click)="loadChatbotFunction()">explore</button></div>